import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IAccountType } from "src/models/HumanResources/AccountTypes.models";

interface AccountTypeState {
  accountTypes: IAccountType[];
  accountTypeToEdit: IAccountType | null;
}

const initialState: AccountTypeState = {
  accountTypes: [],
  accountTypeToEdit: null,
};

const AccountTypeSlice = createSlice({
  name: "AccountType",
  initialState,
  reducers: {
    setAccountTypeList: (state, action: PayloadAction<IAccountType[]>) => {
      state.accountTypes = action.payload;
    },
    concatListAccountType: (
      state: AccountTypeState,
      action: PayloadAction<IAccountType[]>
    ) => {
      state.accountTypes = [...state.accountTypes.concat(action.payload)];
    },
    setAccountTypeToEdit: (
      state,
      action: PayloadAction<IAccountType | null>
    ) => {
      state.accountTypeToEdit = action.payload;
    },
    addAccountType: (state, action: PayloadAction<IAccountType>) => {
      state.accountTypes.push(action.payload);
    },
    updateAccountType: (state, action: PayloadAction<IAccountType>) => {
      let itemIndex = state.accountTypes.findIndex(
        item => item.accountTypeId === action.payload.accountTypeId
      );
      if (itemIndex !== -1) state.accountTypes[itemIndex] = action.payload;
    },
    deleteAccountType: (state, action: PayloadAction<number>) => {
      const newArray = state.accountTypes.filter(
        item => item.accountTypeId !== action.payload
      );
      state.accountTypes = newArray;
    },
  },
});

export const {
  setAccountTypeList,
  concatListAccountType,
  setAccountTypeToEdit,
  addAccountType,
  updateAccountType,
  deleteAccountType,
} = AccountTypeSlice.actions;

export default AccountTypeSlice.reducer;
